const tabIds = {
  EMBED_URL: 'EmbedURL',
  EMBED_CODE: 'EmbedCode',
};

export default tabIds;
